import React, { useEffect, useState } from 'react';
import { Camera, Star } from 'lucide-react';
import { reviewsAPI } from '../services/api';
import ReviewPhotos from './ReviewPhotos';
import { useT } from '../services/i18n';

/** Top-of-page strip with the photos customers attached to their reviews (social proof above the fold). */
const CustomerPhotosStrip = ({ productId }) => {
  const { t } = useT();
  const [gallery, setGallery] = useState([]);
  useEffect(() => {
    let alive = true;
    reviewsAPI.getForProduct(productId).then((d) => { if (alive) setGallery(d?.photo_gallery || []); }).catch(() => {});
    return () => { alive = false; };
  }, [productId]);
  if (!gallery.length) return null;
  const avg = (gallery.reduce((n, g) => n + (g.rating || 0), 0) / gallery.length).toFixed(1);
  return (
    <section className="bg-white rounded-xl shadow-sm p-4 sm:p-5 mt-4" data-testid="customer-photos-strip">
      <div className="flex flex-wrap items-center justify-between gap-2 mb-3">
        <h2 className="text-base md:text-lg font-semibold text-gray-900 flex items-center gap-2">
          <Camera size={18} className="text-orange-500" /> {t('reviews.customerPhotos', { n: gallery.length })}
        </h2>
        <div className="flex items-center gap-3 text-sm">
          <span className="inline-flex items-center gap-1 text-amber-600 font-medium" data-testid="customer-photos-avg"><Star size={14} className="fill-current" /> {avg}</span>
          <a href="#avis" className="text-orange-600 hover:underline" data-testid="customer-photos-see-reviews">{t('reviews.customerPhotosSee')}</a>
        </div>
      </div>
      <ReviewPhotos photos={gallery.map((g) => g.url)} testId="customer-photos" size="w-20 h-20 sm:w-24 sm:h-24" />
      <p className="text-xs text-gray-500 mt-2">{t('reviews.customerPhotosHint')}</p>
    </section>
  );
};

export default CustomerPhotosStrip;
